module.exports = __webpack_public_path__ + "img/tickets-r3-tape-mgt.f0ab910b.png";